import { IItemForGetShortInfo, IDishModifierGroup, ITotalPrice } from 'types';
import { IModifierGroupWithAdditionalData } from 'modules/Menu/Dishes/EditDish/editDishState/editDishContext';
import React from 'react';
import ModifierGroupsMultipleSelect from './components/ModifierGroupsMultipleSelect/ModifierGroupsMultipleSelect';
import DnDList from './components/DnDList';
import ModifierGroupsAsAdditionalMultipleSelect from './components/ModifierGroupsAsAdditionalMultipleSelect/ModifierGroupsAsAdditionalMultipleSelect';
import style from './ModifierGroupsField.module.scss';

interface IModifierGroupsField {
	setModifierGroups: (value: string[]) => void;
	initialModifierGroups: IDishModifierGroup[];
	setFetchedModifierGroups: (value: IItemForGetShortInfo[]) => void;
	totalPrices: ITotalPrice[];
	selectedModifierGroups: string[];
	fetchedModifierGroups: IItemForGetShortInfo[];
	setModifierGroupsAsAdditional: (value: string[]) => void;
	initialModifierGroupsAsAdditional: string[];
	selectedModifierGroupsAsAdditional: string[];
	changeLowerLimit: (id: string, value: string) => void;
	changeUpperLimit: (id: string, value: string) => void;
	toggleLimitsProtectedFromSync: (id: string, value: boolean) => void;
	modifierGroupsWithAdditionalData: IModifierGroupWithAdditionalData[];
}

const ModifierGroupsField: React.FC<IModifierGroupsField> = ({
	selectedModifierGroups,
	initialModifierGroups,
	totalPrices,
	fetchedModifierGroups,
	setModifierGroups,
	setFetchedModifierGroups,
	setModifierGroupsAsAdditional,
	initialModifierGroupsAsAdditional,
	selectedModifierGroupsAsAdditional,
	changeLowerLimit,
	changeUpperLimit,
	toggleLimitsProtectedFromSync,
	modifierGroupsWithAdditionalData,
}) => {
	return (
		<div className={style.container} data-test="ModifierGroupsField">
			<div className={style.field}>
				<ModifierGroupsMultipleSelect
					selectedModifierGroups={selectedModifierGroups}
					totalPrices={totalPrices}
					setModifierGroups={setModifierGroups}
					setFetchedModifierGroups={setFetchedModifierGroups}
					initialModifierGroups={initialModifierGroups}
				/>
			</div>
			<DnDList
				selectedModifierGroups={selectedModifierGroups}
				fetchedModifierGroups={fetchedModifierGroups}
				setModifierGroups={setModifierGroups}
				changeLowerLimit={changeLowerLimit}
				changeUpperLimit={changeUpperLimit}
				toggleLimitsProtectedFromSync={toggleLimitsProtectedFromSync}
				modifierGroupsWithAdditionalData={modifierGroupsWithAdditionalData}
			/>
			<ModifierGroupsAsAdditionalMultipleSelect
				setModifierGroupsAsAdditional={setModifierGroupsAsAdditional}
				fetchedModifierGroups={fetchedModifierGroups}
				selectedModifierGroups={selectedModifierGroups}
				initialModifierGroupsAsAdditional={initialModifierGroupsAsAdditional}
				selectedModifierGroupsAsAdditional={selectedModifierGroupsAsAdditional}
			/>
		</div>
	);
};

export default React.memo(ModifierGroupsField);
